goog.provide('el8.appchart.letters.templates');

goog.require('el8.appchart.dialog.viewAllTemplates');
goog.require('el8.practicedata.letterTemplates');
goog.require('el8.practicedata.letterTemplates');
goog.require('el8.service.urls');
goog.require('el8.template.appchart.letters');
goog.require('el8.uiwidget.NewActionsMenu');


/**
 * This file manages the template portion of the letter pane.
 * createMenu() should be called on every letter pane show and
 * destroyMenu() on every pane hide
 */
el8.appchart.letters.templates = (function() {

    var NUM_TEMPLATES_VISIBLE = 10;

    var templateList = null; // we can share this across all letters
     // this needs to be reconstructed on every letter show, because the container is destroyed on letter hide
    var actionsMenu = null;

    return {

        getList: function() { return templateList; },
        getActionsMenu: function() { return actionsMenu; },

        // called to initially populate the template menu and create an actions menu
        createMenu: function(container) {
            if (!templateList) { rebuildList(); }
            actionsMenu = new el8.uiwidget.NewActionsMenu({
                container: container,
                anchorTop: $('#letter-form', container),
                menuId: 'letter-templates-menu',
                width: 350
            });
            $('.letter-template-section', container).show();

            el8.practicedata.letterTemplates.bind('all', rebuildList);
        },

        destroyMenu: function() {
            actionsMenu = null;
            el8.practicedata.letterTemplates.unbind('all', rebuildList);
        },

        saveFormAsTemplate: function() {
            var form = el8.appchart.letters.main.getForm();

            var templateKeys = {
                body: form.getVal('body'),
                subject: form.getVal('subject')
            };
            el8.appchart.dialog.saveTemplate.show({
                templateKeys: templateKeys,
                templateSet: el8.practicedata.letterTemplates,
                urlKey: 'letterTemplates'
            });
        },

        useTemplate: useTemplate

    };


    // called anytime when we want to force the template menu to update
    function rebuildList() {
        var visibleTemplates = el8.practicedata.letterTemplates.all().slice(0, NUM_TEMPLATES_VISIBLE);
        templateList = visibleTemplates.map(function(template) {
            var templateName = template.getName();
            if (template.getBody()) {
                // if the template has a body, add the beginning of the body to the action menu
                var body = template.getBody().replace(/[\n\r]/g, ' ');
                body = body.substr(0, 50);
                templateName += ' - ' + body + '...';
            }
            return {
                actionText: templateName,
                actionFn: function() {
                    useTemplate(template);
                }
            };
        });
        templateList.push({
            actionText: 'See All Templates',
            actionFn: function() {
                el8.appchart.dialog.viewAllTemplates.show({
                    templateSet: el8.practicedata.letterTemplates,
                    selectedCb: useTemplate
                });
            }
        });
    }

    // populate the letter, based on a letter template
    function useTemplate(template, noTrigger) {
        if (!el8.appchart.mgr.thirdpane.isLetterOpen()) { return; }
        var form = el8.appchart.letters.main.getForm();

        if (template.getSubject()) { // many templates will have no subject
            var existingSubject = form.getVal('subject');
            var newSubject = (existingSubject) ? existingSubject + ' ' : existingSubject;
            newSubject += template.getSubject();
            form.setVal('subject', newSubject, noTrigger);
        }

        var existingBody = form.getVal('body');

        // if the existing body is one of our pre-filled bodies, have the template replace instead of add
        if (existingBody === el8.template.appchart.letters.defaultFaxBody() ||
            existingBody === el8.template.appchart.letters.defaultDirectMessageBody()) { existingBody = ''; }

        var newBody = (existingBody) ? existingBody + '\n\n' : existingBody;
        newBody += template.getBody();
        form.setVal('body', newBody, noTrigger);
        if (!noTrigger) {
            form.getInputField('body').change(); //need to trigger a save here
        }
    }

})();
